<klt-table-v2
  [columns]="allReitTableData.headers"
  [columnGroups]="allReitTableData.sections"
></klt-table-v2>
